import axios from "axios";

// retrieve shared vars
let shared = window['CONFIG'];

// retrieve user
let user = shared.user;
if (user) {
    user.crediti = shared.crediti;
}

// auth
const _token = shared.access_token;
const token = {
    get() {
        return _token;
    },
    exists() {
        return !!_token;
    },
    user() {
        return null;
    }
}

// check login
const guardAuth = function( afterSign = null ) {
    const _loginRedirect = window['CONFIG'].routes['login'];
    if (!user) {
        // if is guest than redirect to login
        self.location.href = _loginRedirect + (afterSign ? `?afterSign=${afterSign}` : "");
        return false;
    }
    return true;
}

// rest
var instance = axios.create({
    baseURL: document.body.dataset['api_base_url'],
    // baseURL: 'http://schoolvisor.local/api',
    // timeout: 10000,
    headers: {"X-Access-Token": token.get()},
    transformResponse: [function (res) {
        res = JSON.parse(res);
        if (res.data && res.data.redirect) {
            self.location.href = res.data.redirect;
            return;
        }
        return res;
    }],
});

const api = (config) => {
    return new Promise<any>( (resolve, reject) => {
        if (config.loading) {
            config.loading.setState({loading: true});
        }
        instance.request( config ).then( (res) => {
            if (config.rawRespone) {
                const { status } = res;
                if (status != 200 && status != 201) {
                    reject(res);
                } else {
                    resolve(res);
                }
            } else {
                const { errors, data, message, status_code } = res.data;
                if (errors || (status_code != 200 && status_code != 201)) {
                    reject( message || errors );
                } else {
                    resolve( data );
                }
            }
            if (config.appActions && appContext) {
                appContext.gotResponse(res);
            }
            if (config.loading) {
                config.loading.setState({loading: false});
            }
        })
        .catch( (res) => {
            console.log(res)
            reject( res );
            if (config.appActions && appContext) {
                appContext.gotResponse(res);
            }
            if (config.loading) {
                config.loading.setState({loading: false});
            }
        });
    });
}

var appContext;
const bindToApp = (context) => {
    appContext = context;
}

const objectid = () => {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
}
const dataList = {
    objectid: objectid,
    // updates one item into array with values
    update: (arr_src, values, item) => {
        var arr = arr_src.slice();
        if (item) {
            // update
            arr.forEach( (i, index) => {
                if (i.id == item.id) {
                    arr[index] = { ...item, ...values };
                }
            });
          
        } else{
            // create
            arr.push( { id: objectid(), ...values } );
        }
        return arr;
    },
    // put a true in field on item and false on the others
    flag: (arr_src, field, item) => {
        let arr = arr_src.slice();
        arr = arr.map( (i) => {
            return {
                ...i,
                [field]: (i.id == item.id)
            };
        });
        return arr;
    },
    destroy: (arr_src, item) => {
        var arr = arr_src.slice();
        arr.forEach( (i, index) => {
            if (i.id == item.id) {
                arr.splice(index, 1);
            }
        });
        return arr;
    },
    // divide an array into chunks
    chunk: (arr, chunk_size) => {
        if (arr.length === 0) { return []; }
        arr = Array.from(arr);
        var results = [] as any;
        
        while (arr.length) {
            results.push(arr.splice(0, chunk_size));
        }
        
        return results;
    }
};

export {
    token,
    user,
    shared,
    guardAuth,
    api,
    bindToApp,
    dataList
};


// WEBPACK FOOTER //
// ./src/services/api.ts